import { getFirstAvailableWeek } from '@epicuro-next/utilities';
import { DeliveryWindowType, OrderType } from 'graphql-api/gql-api-interfaces';

import { DeliveryItems, DeliveryPeriodType } from '../../models';

export function isMonthType(type: DeliveryWindowType | undefined): boolean {
  return type === DeliveryWindowType.Month;
}

export function isWeekType(type: DeliveryWindowType | undefined): boolean {
  return type === DeliveryWindowType.Week;
}

export function isNowDeliveryItems(deliveryItems: DeliveryItems): boolean {
  return (
    deliveryItems.orderType === OrderType.Now &&
    deliveryItems.deliveryPeriodType === DeliveryPeriodType.Now
  );
}

export function getDateByDeliveryWindowType(
  deliveryWindowType: DeliveryWindowType,
  date: Date,
  firstMonth: string,
): Date {
  if (isWeekType(deliveryWindowType)) {
    return getFirstAvailableWeek(date);
  }
  if (isMonthType(deliveryWindowType)) {
    return new Date(firstMonth);
  }
  return date;
}
